import React from 'react';
import { Link } from 'react-router-dom';
import Gallery from '../components/Gallery';

const Icon = {
  Arrow: (props) => (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...props}>
      <path d="M7 17l9.2-9.2M17 17V7H7" />
    </svg>
  ),
  Doc: (props) => (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...props}>
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
      <path d="M14 2v6h6" />
    </svg>
  ),
  Stats: (props) => (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...props}>
      <path d="M3 3v18h18" /><path d="M7 14h3v4H7zM12 10h3v8h-3zM17 6h3v12h-3z" />
    </svg>
  ),
  Quote: (props) => (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...props}>
      <path d="M3 21c3.333-4 5-6 5-8V5a2 2 0 012-2h8a2 2 0 012 2v8c0 2-1.667 4-5 8" />
    </svg>
  ),
};

function getServiceIcon(name) {
  const n = name.toLowerCase();
  if (n.includes('artículo') || n.includes('observaciones') || n.includes('monografia') || n.includes('ensayo')) return <Icon.Doc className="text-gray-700" />;
  if (n.includes('parafraseo')) return <Icon.Quote className="text-gray-700" />;
  if (n.includes('planes') || n.includes('negocio') || n.includes('diapositivas') || n.includes('inteligencia')) return <Icon.Stats className="text-gray-700" />;
  return <Icon.Doc className="text-gray-700" />;
}

export default function Servicios({ services = [] }) {
  return (
    <div className="pt-24 bg-white">
      {/* Hero */}
      <section className="relative overflow-hidden bg-gradient-to-b from-brand/5 to-transparent border-b border-brand/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 lg:py-36">
          <div className="max-w-3xl">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black tracking-tight text-gray-900">
              Nuestros Servicios
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-gray-600 max-w-2xl">
              Soluciones académicas personalizadas para cada etapa de tu proyecto de investigación. Asesoría especializada con garantía de calidad.
            </p>
          </div>
        </div>
      </section>

      {/* Servicios Grid */}
      <section className="py-20 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((s) => {
              const path = s.path ? `/servicios/${s.path}` : `/servicios/${encodeURIComponent(s.name.toLowerCase().replaceAll(' ', '-'))}`;
              return (
                <Link
                  key={s.name}
                  to={path}
                  className="group block bg-white rounded-xl p-8 border-2 border-gray-200 hover:border-brand hover:shadow-xl transition-all duration-300"
                >
                  <div className="w-14 h-14 rounded-lg bg-brand/10 grid place-items-center mb-5 group-hover:bg-brand/20 transition text-brand">
                    {getServiceIcon(s.name)}
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">{s.name}</h3>
                  <p className="text-sm text-brand font-bold mt-2">
                    {typeof s.price === 'number' ? `Desde S/ ${s.price.toLocaleString()}` : s.price}
                  </p>
                  <p className="mt-3 text-gray-600 leading-relaxed text-sm">
                    Asesoría especializada con acompañamiento personalizado y entregables claros por hitos.
                  </p>
                  <div className="mt-6 flex items-center gap-2 text-brand font-bold group-hover:gap-3 transition-all text-sm">
                    Solicitar información <Icon.Arrow className="text-brand" />
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* Galería: entregas recientes */}
      <section id="entregas" className="py-12 lg:py-16 bg-white border-t border-brand/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-1 h-8 bg-brand rounded-full" />
            <h2 className="text-3xl font-black text-gray-900">Entregas exitosas</h2>
          </div>
          <p className="text-gray-600 mb-6">Ejemplos de trabajos entregados por nuestro equipo.</p>
          <Gallery />
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-b from-brand/5 to-transparent border-t-2 border-brand/20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">¿No ves el servicio que necesitas?</h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            Contáctanos y cuéntanos sobre tu proyecto. Probablemente podamos personalizarlo para tus necesidades específicas.
          </p>
          <a
            href="https://wa.me/+51983318651?text=Hola, tengo una consulta sobre un servicio específico"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 mt-8 bg-green-500 text-white font-bold rounded-xl hover:bg-green-600 transition shadow-lg hover:shadow-2xl hover:scale-105"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.297-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.263c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.485"/></svg>
            Chatear por WhatsApp
          </a>
        </div>
      </section>
    </div>
  );
}
